import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Content from './components/Content';
import Footer from './components/Footer';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import AdminDashboard from './pages/AdminDashboard';
import QuizPage from './pages/QuizPage';
import QuizList from './pages/QuizList';
import NotFound from './pages/NotFound';
import CourseDetails from './pages/CourseDetails';
import TestResult from './pages/TestResults'; // Import the new TestResult page
import UserProfile from './pages/UserProfile'; // Import the new UserProfile page
import Logout from './pages/Logout';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('isLoggedIn') === 'true');
  const [userRole, setUserRole] = useState(localStorage.getItem('userRole') || '');
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')) || null);

  useEffect(() => {
    if (isLoggedIn && userRole) {
      localStorage.setItem('isLoggedIn', 'true');
      localStorage.setItem('userRole', userRole);
      if (user) {
        localStorage.setItem('user', JSON.stringify(user));
      }
    } else {
      localStorage.clear();
    }
  }, [isLoggedIn, userRole, user]);

  const handleLoginSuccess = (user) => {
    setIsLoggedIn(true);
    setUserRole(user.role);
    setUser(user);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setUserRole('');
    setUser(null);
    localStorage.clear();
  };

  const GuardedRoute = ({ children, role }) => {
    if (!isLoggedIn) {
      return <Navigate to="/login" replace />;
    }
    if (role && userRole !== role) {
      return <Navigate to="/" replace />;
    }
    return children;
  };

  return (
    <Router>
      <div className="App">
        <Header isLoggedIn={isLoggedIn} onLogout={handleLogout} />

        <Routes>
          <Route path="/" element={<Content />} />
          <Route path="/login" element={<Login onLoginSuccess={handleLoginSuccess} />} />
          <Route path="/register" element={<Register />} />
          <Route path="/course/:id" element={<CourseDetails />} />
          <Route path="/test-results" element={<GuardedRoute role="user"><TestResult user={user} /></GuardedRoute>} />
          <Route path="/dashboard" element={<GuardedRoute role="user"><Dashboard user={user} /></GuardedRoute>} />
          <Route path="/quizlist/:courseId" element={<GuardedRoute role="user"><QuizList user={user} /></GuardedRoute>} />
          <Route path="/quiz/:courseId/:quizId" element={<GuardedRoute role="user"><QuizPage user={user} /></GuardedRoute>} />
          <Route path="/profile" element={<GuardedRoute role="user"><UserProfile user={user} /></GuardedRoute>} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/admin/*" element={<GuardedRoute role="admin"><AdminDashboard user={user} /></GuardedRoute>} />
          <Route path="*" element={<NotFound />} />
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
